(function () {
    var quickAdds = document.querySelectorAll('[data-quick-add]')
    var saveForLaters = document.querySelectorAll('[data-save-for-later]')

    if (quickAdds.length > 0) {
        quickAdds.forEach(quickAdd => quickAdd.addEventListener('click', function (e) {
            e.preventDefault()

            var product_id = quickAdd.getAttribute('data-quick-add')
            var type = quickAdd.getAttribute('data-type')

            let formData = new FormData()
            formData.append(type + "_id", product_id)
            formData.append("quantity", 1)
            formData.append("action", "add-" + type)

            fetch("/scripts/basket-manager.php", {
                method: "POST",
                body: formData
            }).then(res => res.json()).then(data => {

                if (document.querySelector('.header__nav__action__count.hnac--basket')) {
                    document.querySelector('.header__nav__action__count.hnac--basket').innerHTML = data.totals.total_products
                } else {
                    var basketNavCount = document.createElement('span')
                    basketNavCount.classList.add('header__nav__action__count', 'hnac--basket')
                    basketNavCount.innerHTML = data.totals.total_products

                    document.querySelector('[data-nav-basket]').querySelector('.header__nav__action__label').appendChild(basketNavCount)
                }

                if (document.querySelector('[data-sticky-quantity]')) {
                    document.querySelector('[data-sticky-quantity]').innerHTML = data.totals.total_products
                } else {
                    fetch("/scripts/sticky-basket-nav.php", {
                        method: "POST"
                    }).then(res => res.json()).then(data => {
                        document.querySelector('body').insertAdjacentHTML("beforeend", data.content)
                        setTimeout(stickyBasket, 500)
                    })
                }

                quickAdd.innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> Added'

                if (document.querySelector('[data-layout]').getAttribute('data-layout') == 'basket') {
                    window.location.reload()
                } else {
                    setTimeout(() => {
                        quickAdd.innerHTML = "Add to Basket"
                    }, 5000)
                }

            })
        }))
    }

    if (saveForLaters.length > 0) {
        saveForLaters.forEach(saveForLater => saveForLater.addEventListener('click', function (e) {
            e.preventDefault()

            var product_id = saveForLater.getAttribute('data-save-for-later')
            var type = saveForLater.getAttribute('data-type')

            let formData = new FormData()
            formData.append("product_id", product_id)
            formData.append("type", type)
            formData.append("action", "save-product-for-later")

            fetch("/scripts/basket-manager.php", {
                method: "POST",
                body: formData
            }).then(res => res.json()).then(data => {

                if (document.querySelector('[data-sticky-quantity]')) {
                    document.querySelector('[data-sticky-quantity]').innerHTML = data.totals.total_products
                } else {
                    fetch("/scripts/sticky-basket-nav.php", {
                        method: "POST"
                    }).then(res => res.json()).then(data => {
                        document.querySelector('body').insertAdjacentHTML("beforeend", data.content)
                        setTimeout(stickyBasket, 500)
                    })
                }

                saveForLater.innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> Saved'

                if (document.querySelector('[data-layout]').getAttribute('data-layout') == 'basket') {
                    window.location.reload()
                } else {
                    setTimeout(() => {
                        saveForLater.innerHTML = 'Save <svg xmlns="http://www.w3.org/2000/svg" class="quick-add-svg-saved" viewBox="0 0 100 100"><path fill="currentColor" d="M 10,30 A 20,20 0,0,1 50,30 A 20,20 0,0,1 90,30 Q 90,60 50,90 Q 10,60 10,30 z"></path></svg>'
                    }, 5000)
                }

            })
        }))
    }
})()